// src/components/common/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({
  element: Component,
  permission,
  redirectTo = "/",
}) => {
  return permission ? <Component /> : <Navigate to={redirectTo} replace />;
};

export default ProtectedRoute;
